export const copyText = (text: string): void => {
  void navigator.clipboard.writeText(text);
};
